import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  TextField,
  Table,
  TableBody,
  AppBar,
  Toolbar,
  Typography,
  CircularProgress,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container,
  Paper,
  InputAdornment,
} from "@mui/material";
import LoadingBar from "react-top-loading-bar";
import SearchIcon from "@mui/icons-material/Search";
import base64 from "base64-js";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Organization = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [authorization, setAuthorization] = useState([]);
  const [canEdit, setCanEdit] = useState(true); // Default to true, assuming user can edit
  const { encodedFormId } = useParams();

  const decodeFormId = (encodedFormId) => {
    const bytes = base64.toByteArray(encodedFormId);
    return new TextDecoder().decode(bytes);
  };
  const formId = decodeFormId(encodedFormId);
  console.log(formId);

  const handleAddOrganization = () => {
    navigate("/addOrganization");
    console.log("Navigate to Add Organization page");
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };


  const fetchOrganizationData = async () => {
    try {
      setLoading(true); // Set loading to true when starting the fetch
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Organization/GetOrganization`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const responseData = await response.json();
        setData(responseData);
      } else {
        console.error("Account name incorrect");
        // alert("Invalid account name");
        setSnackbarMessage('Invalid account name');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning");
      }
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
    } finally {
      setLoading(false); // Set loading to false after fetch completes
    }
  };


  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          formId,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setAuthorization(responseData);
        const authorizationData = responseData[0];
        setCanEdit(authorizationData.uModify === 1);
      } else {
        console.error("Country name incorrect");
        // alert("Invalid country name");
        setSnackbarMessage('Invalid country name');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning");
      }
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
    }
  };

  useEffect(() => {
    const filtered = data.filter((org) =>
      org.schoolName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
  }, [data, searchTerm]);


  useEffect(() => {
    fetchOrganizationData();
    Authorizer();
  }, []);

  return (
    <Container>
      <LoadingBar
        progress={loadingBarProgress}
        color="rgb(152, 106, 182)"
        height={5}
      />
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Organization
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper
        elevation={3}
        style={{ padding: 16, width: "100%", margin: "auto", marginTop: 6 }}
      >
        <div className="container mt-4">
          <div
            className="container mt-2"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              marginBottom: "1rem",
            }}
          >
            <TextField
              variant="outlined"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleInputChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                style: { padding: "0px 8px" },
              }}
              sx={{
                width: 300,
                backgroundColor: "#f9f9f9",
              }}
            />
          </div>

          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table
              sx={{
                minWidth: 650,
                border: '1px solid #ccc',
                '& .MuiTableCell-root': {
                  borderRight: '1px solid #ccc', // vertical line
                  fontSize: '1rem', // increased font size
                },
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell><b>Organization Name</b></TableCell>
                  <TableCell><b>Email-Id</b></TableCell>
                  <TableCell><b>Mobile No.</b></TableCell>
                  <TableCell align="center"><b>Action</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredData.length > 0 ? (
                  filteredData.map((row) => (
                    <TableRow key={row.schoolId}>
                      <TableCell>{row.schoolName}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{row.mobileNo}</TableCell>
                      <TableCell align="center">
                        <Tooltip
                          title={canEdit ? "" : "You are not authorized to edit"}
                          arrow
                        >
                          <span>
                            <Button
                              variant="contained"
                              color="warning"
                              onClick={() =>
                                navigate(`/editOrganization/${row.schoolId}`, {
                                  state: { encodedFormId },
                                })
                              }
                              disabled={!canEdit}
                            >
                              Edit
                            </Button>
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No Organizations Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

            </Table>
          </TableContainer>

        </div>
      </Paper>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default Organization;
